import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { Product } from '@photobooth/types';

export function useProducts() {
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.products.getAll();
      if (response.success && response.data) {
        // Handle nested data structure from API client
        const productsData = (response.data as any).data || response.data;
        setProducts(Array.isArray(productsData) ? productsData : []);
      } else {
        setError('Failed to fetch products');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch products');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return {
    products,
    isLoading,
    error,
    refetch: fetchProducts,
  };
}
